import React from 'react';

import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const PROPOSAL_CHECKOUT_CHUNK_NAME = 'checkout';

export const CheckoutPage = createRouteLoadable(
  () => import(/* webpackChunkName: "checkout" */ '../../pages/CheckoutPage'),
  {
    fallback: <PageSkeleton />,
  }
);

export const ProposalThankYouPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "checkout" */ '../../pages/ProposalThankYouPage'
    ),
  {
    fallback: <PageSkeleton />,
  }
);
